var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"con"},_vm._l((_vm.list),function(x,i){return _c('ImageCard',_vm._b({key:i,class:{ completion: x.comple, half: !x.comple }},'ImageCard',x,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }